var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuleCard',{ref:"module_card",staticClass:"width-100",attrs:{"flowData":_vm.flowData,"menuItems":_vm.enabledMenuItems,"loading":_vm.duplicatingWorkflow}})
}
var staticRenderFns = []

export { render, staticRenderFns }